import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

// material-ui
import { Stack, Typography } from '@mui/material';

// project-imports
import MainCard from 'components/MainCard';
import useAuth from 'hooks/useAuth';

// assets
import { Lock1 } from 'iconsax-react';

// types
import { Permission } from 'utils/permissions';

// ==============================|| PERMISSION GUARD ||============================== //
//
// Explains itself rather than showing an empty page to an admin who opened a URL their role does not
// reach. Courtesy only: the endpoints behind the page answer 403 regardless.

interface Props {
  permission: Permission;
  children: ReactNode;
}

const PermissionGuard = ({ permission, children }: Props) => {
  const { can } = useAuth();

  if (can(permission)) {
    return <>{children}</>;
  }

  return (
    <MainCard>
      <Stack alignItems="center" spacing={1.5} sx={{ py: 6 }}>
        <Lock1 size={32} variant="Bulk" />
        <Typography variant="h5">
          <FormattedMessage id="access.denied.title" />
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center" sx={{ maxWidth: 460 }}>
          <FormattedMessage id="access.denied.text" />
        </Typography>
      </Stack>
    </MainCard>
  );
};

export default PermissionGuard;
